import AutoSizer from 'react-virtualized-auto-sizer';
import { FixedSizeList } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';

import columnMappings from '~/components/columnMappings';
import ColumnSelectorMenu from '~/components/DynamicTable/ColumnSelectorMenu';
import DynamicTable from '~/components/DynamicTable/DynamicTable';
import EmptyPlaceholder from '~/components/EmptyPlaceholder';
import EmptySearch from '~/components/EmptySearch';
import EmptySegmentPlaceholder from '~/components/EmptySegmentPlaceholder';
import LoadingArea from '~/components/LoadingArea';

import Company from './Company';
import loader from './loader.png';
import styles from './styles';

const listItemHeight = 58;

function CompaniesList({
  classes,
  columns,
  companies,
  companiesHasNextPage,
  companiesTotalCount,
  integrate,
  loading,
  onLoadMore,
  refetchQuery,
  searchQuery,
  segmentId,
}) {
  const areItemsEmpty = companiesTotalCount == 0;

  const isItemLoaded = (index) => {
    return !companiesHasNextPage || index < companies.length;
  };

  let emptyPlaceholder;

  if (segmentId && !searchQuery) {
    emptyPlaceholder = (
      <EmptySegmentPlaceholder
        segmentType="Company"
        segmentId={segmentId}
        searchQuery={searchQuery}
      />
    );
  } else if (searchQuery) {
    emptyPlaceholder = (
      <EmptySearch
        segmentType="Company"
        searchQuery={searchQuery}
        inSegment={segmentId !== undefined}
      />
    );
  } else {
    emptyPlaceholder = <EmptyPlaceholder integrate={integrate} />;
  }

  if ((loading && !companies) || companies.length == 0)
    return (
      <LoadingArea
        empty={areItemsEmpty}
        loading={loading}
        emptyBody={emptyPlaceholder}
      />
    );

  return (
    <div className={classes.root}>
      <DynamicTable
        actions={
          <ColumnSelectorMenu
            columns={columns}
            type="Company"
            onColumnsChanged={(columns) => columns && refetchQuery()}
            segmentId={segmentId}
          />
        }
        columnMapping={columnMappings}
        columns={columns}>
        <AutoSizer>
          {({ height, width }) => (
            <InfiniteLoader
              isItemLoaded={isItemLoaded}
              itemCount={companiesTotalCount}
              loadMoreItems={onLoadMore}>
              {({ onItemsRendered, ref }) => (
                <FixedSizeList
                  height={height}
                  itemCount={companies.length}
                  itemSize={listItemHeight}
                  onItemsRendered={onItemsRendered}
                  ref={ref}
                  width={width}>
                  {(listProps) => (
                    <Company
                      columns={columns}
                      company={companies[listProps.index]}
                      segmentId={segmentId}
                      {...listProps}
                    />
                  )}
                </FixedSizeList>
              )}
            </InfiniteLoader>
          )}
        </AutoSizer>
      </DynamicTable>

      {loading && <img alt="" className={classes.loader} src={loader} />}
    </div>
  );
}

CompaniesList.propTypes = {
  classes: PropTypes.object.isRequired,
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  companies: PropTypes.array,
  companiesHasNextPage: PropTypes.bool,
  companiesTotalCount: PropTypes.number,
  integrate: PropTypes.bool,
  loading: PropTypes.bool,
  onLoadMore: PropTypes.func.isRequired,
  refetchQuery: PropTypes.func.isRequired,
  searchQuery: PropTypes.string,
  segmentId: PropTypes.string,
};

export default withStyles(styles)(CompaniesList);
